<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>约课管理</Breadcrumb-item>
        <Breadcrumb-item>常规课程列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
    <Form :label-width="60" :show-message="false">

  <Row :gutter="12">
    <!-- 上课时间行 -->
    <Col :xs="24" :sm="24" :md="12" :lg="6">
      <Form-item label="上课时间">
        <Row :gutter="8">
          <Col :xs="24" :sm="11" :md="11" :lg="11">
            <Date-picker
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              placeholder="开始时间"
              @on-change="startTimeDateChange"
              v-model="queryParam.startTimeDate"
              style="width: 100%"
            />
          </Col>
          <Col :xs="24" :sm="11" :md="11" :lg="11">
            <Date-picker
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              placeholder="结束时间"
              @on-change="endTimeDateChange"
              v-model="queryParam.endTimeDate"
              style="width: 100%"
            />
          </Col>
        </Row>
      </Form-item>
    </Col>

    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="学导">
        <admin-user-select
          :status="1"
          adminGroupCode="userStudyAdviser"
          v-model="queryParam.adminUserId"
          style="width: 100%"
        />
      </Form-item>
    </Col>

    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="课程顾问">
        <admin-user-select
          :status="1"
          adminGroupCode="adviser"
          v-model="queryParam.adviserId"
          style="width: 100%"
        />
      </Form-item>
    </Col>

    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="老师ID">
        <Input
          name="tchId"
          v-model="queryParam.tchId"
          style="width: 100%"
        />
      </Form-item>
    </Col>

    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="老师姓名">
        <Input
          placeholder="支持模糊搜索"
          name="tchName"
          v-model="queryParam.tchName"
          style="width: 100%"
        />
      </Form-item>
    </Col>
  </Row>

  <!-- 排课时间行 -->
  <Row :gutter="12">
    <Col :xs="24" :sm="24" :md="12" :lg="6">
      <Form-item label="排课时间">
        <Row :gutter="8">
          <Col :xs="24" :sm="11" :md="11" :lg="11">
            <Date-picker
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              placeholder="开始时间"
              @on-change="startCreateTimeChange"
              v-model="queryParam.startCreateDate"
              style="width: 100%"
            />
          </Col>
          <Col :xs="24" :sm="11" :md="11" :lg="11">
            <Date-picker
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              placeholder="结束时间"
              @on-change="endCreateTimeChange"
              v-model="queryParam.endCreateDate"
              style="width: 100%"
            />
          </Col>
        </Row>
      </Form-item>
    </Col>

    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="课程类别">
        <Select
          v-model.number="queryParam.courseType"
          placeholder="全部"
          @on-change="search"
          clearable
          style="width: 100%"
        >
          <Option v-for="item in $constant.courseType" :value="item.code" :key="item.code">
            {{ item.text }}
          </Option>
        </Select>
      </Form-item>
    </Col>

    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="学生ID">
        <Input
          name="uid"
          v-model="queryParam.uid"
          style="width: 100%"
        />
      </Form-item>
    </Col>

    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="学生昵称">
        <Input
          placeholder="支持模糊搜索"
          name="userNickname"
          v-model="queryParam.userNickname"
          style="width: 100%"
        />
      </Form-item>
    </Col>

    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="教材版本">
        <Select
          v-model.number="queryParam.materialVersionId"
          @on-change="search"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <Option v-for="item in $constant.materialVersions" :key="item.code" :value="item.code">
            {{ item.text }}
          </Option>
        </Select>
      </Form-item>
    </Col>
  </Row>

  <!-- 注册时间行 -->
  <Row :gutter="12">
    <Col :xs="24" :sm="24" :md="12" :lg="6">
      <Form-item label="注册时间">
        <Row :gutter="8">
          <Col :xs="24" :sm="11" :md="11" :lg="11">
            <Date-picker
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              placeholder="开始时间"
              @on-change="startTimeRegChange"
              v-model="queryParam.regStartDate"
              style="width: 100%"
            />
          </Col>
          <Col :xs="24" :sm="11" :md="11" :lg="11">
            <Date-picker
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              placeholder="结束时间"
              @on-change="endTimeRegChange"
              v-model="queryParam.regEndDate"
              style="width: 100%"
            />
          </Col>
        </Row>
      </Form-item>
    </Col>

    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="学生手机号" :label-width="75">
        <Input
          placeholder="支持模糊搜索"
          name="userMobile"
          v-model="queryParam.userMobile"
          style="width: 100%"
        />
      </Form-item>
    </Col>

    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="课程状态">
        <Select
          v-model="queryParam.lsnSelStatus"
          placeholder="全部"
          @on-change="search"
          clearable
          style="width: 100%"
        >
          <Option v-for="item in $constant.lsnSelStatus" :value="item.code" :key="item.code">
            {{ item.text }}
          </Option>
        </Select>
      </Form-item>
    </Col>

    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="老师类型">
        <Select
          v-model.number="queryParam.tchCategory"
          placeholder="全部"
          @on-change="search"
          clearable
          style="width: 100%"
        >
          <Option v-for="item in $constant.teacherCategory" :value="item.code" :key="item.code">
            {{ item.text }}
          </Option>
        </Select>
      </Form-item>
    </Col>

    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="课程类型">
        <Select
          v-model.number="queryParam.lsnType"
          placeholder="全部"
          @on-change="search"
          clearable
          style="width: 100%"
        >
          <Option v-for="item in $constant.bookLessonOpenedLsnType" :value="item.code" :key="item.code">
            {{ item.text }}
          </Option>
        </Select>
      </Form-item>
    </Col>
  </Row>

  <!-- 其他筛选条件行 -->
  <Row :gutter="12">
    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="外教运营">
        <Select
          v-model.number="queryParam.tchStudyAdviserId"
          placeholder="全部"
          @on-change="search"
          clearable
          style="width: 100%"
        >
          <Option v-for="item in tchStudyAdviserList"
                  :value="item.id" :key="item.id">{{ item.nickname }}
          </Option>
        </Select>
      </Form-item>
    </Col>

    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="渠道" :label-width="40">
        <channel-select
          v-model="queryParam.regType"
          style="width: 100%"
        />
      </Form-item>
    </Col>

    <Col :xs="24" :sm="12" :md="6" :lg="5">
      <FormItem :label-width="80" label="渠道来源：">
        <Select
          v-model="queryParam.tchChannel"
          clearable
          placeholder="请选择"
          style="width: 100%"
        >
          <Option v-for="item in $constant.tchChannel"
                  :value="item.code" :key="item.code">{{ item.text }}
          </Option>
        </Select>
      </FormItem>
    </Col>
    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="是否复习课" :label-width="80">
        <Select
          v-model.number="queryParam.isLastSection"
          placeholder="全部"
          @on-change="search"
          clearable
          style="width: 100%"
        >
          <Option v-for="item in $constant.yesNoNum" :value="item.code" :key="item.code">
            {{ item.text }}
          </Option>
        </Select>
      </Form-item>
    </Col>
    <Col :xs="24" :sm="12" :md="6" :lg="4">
      <Form-item label="课程ID">
        <Input
          name="bookLessonOpenedId"
          v-model="queryParam.bookLessonOpenedId"
          style="width: 100%"
        />
      </Form-item>
    </Col>
    <Col :xs="24" :sm="24" :md="12" :lg="8">
      <Form-item label="课件">
        <Row :gutter="8">
          <Col :span="12">
            <Select
              v-model.number="queryParam.levelId"
              filterable
              clearable
              transfer
              placeholder="Level"
              @on-change="changeMaterialLevel"
              style="width: 100%"
            >
              <Option v-for="item in bookMaterialLevelList" :value="item.id" :key="'lv-' + item.id">
                {{ item.title }}
              </Option>
            </Select>
          </Col>
          <Col :span="12">
            <Select
              v-model.number="queryParam.lessonId"
              filterable
              clearable
              transfer
              placeholder="Lesson"
              @on-change="search"
              style="width: 100%"
            >
              <Option v-for="item in bookMaterialLessonsList" :value="item.id" :key="'ls-' + item.id">
                {{ item.id }}-{{ item.title }}
              </Option>
            </Select>
          </Col>
        </Row>
      </Form-item>
    </Col>
  </Row>
  <Row :gutter="12">
    <Col :xs="24" :sm="12" :md="6" :lg="6">
        <Button
          type="primary"
          :loading="searchLoading"
          :disabled="searchLoading"
          icon="search"
          @click="search"
          style="margin-bottom: 5px; margin-right: 5px"
        >
          搜索
        </Button>
        <Button
          type="primary"
          :loading="exportLoading"
          :disabled="exportLoading"
          icon="ios-download-outline"
          v-perm="'619'"
          @click="exportData"
          style="margin-bottom: 5px; margin-right: 5px"
        >
          导出
        </Button>
        <Button
          type="primary"
          @click="batchCancelLesson"
          style="margin-bottom: 5px; margin-right: 5px;"
        >
          批量取消课程
        </Button>
        <Checkbox v-model="showCameraStatus">课前是否打开摄像头</Checkbox>
    </Col>
  </Row>
</Form>


      <Modal title="新增统一放假" v-model="unifiedHolidayModal" width="600">
        <Form ref="holidayForm" class="form" :model="holidayParam" :rules="holidayRule" :label-width="80">
          <Row>
            <i-col :span="22">
              <Form-item label="放假时间">
                <Row>
                  <Col span="11">
                    <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                                 @on-change="startTimeHolidayChange" v-model="holidayParam.startTime"/>
                  </Col>
                  <Col span="2" style="text-align: center">-</Col>
                  <Col span="11">
                    <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                                 @on-change="endTimeHolidayChange" v-model="holidayParam.endTime"/>
                  </Col>
                </Row>
              </Form-item>
            </i-col>
          </Row>
          <Row>
            <i-col :span="22">
              <Form-Item label="内容：" prop="content">
                <Input v-model="holidayParam.content" type="textarea" :rows="4"/>
              </Form-Item>
            </i-col>
          </Row>
        </Form>
        <div slot="footer">
          <Button type="text" size="large" @click="unifiedHolidayModal=false">取消</Button>
          <Button type="primary" size="large" @click="saveHoliday">保存</Button>
        </div>
      </Modal>


    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookLesson/opened/list" class="opened-list"
          :params="queryParam" :onLoading="onLoading" :reloadWithPage="reloadWithPage" operator=""
          @on-selection-change="selectedChange"/>

    <ChangeLessonModal :lessonOpened="lessonOpened" v-model="showChangeLessonModal" :successCallback="searchWithPage"/>
    <ChangeClassTypeModal :classType="classType" v-model="showChangeLClassTypeModal"/>
    <AddMonitorLessonRecordModal :openedId="openedId" v-model="showMonitorLessonRecordModal"/>
    <AddLessonFeedbackModal :openedId="openedId" :studentName="studentName" :teacherName="teacherName" :lessonTime="lessonTime" v-model="addLessonFeedbackModal"/>
    <TchLessonLeaveModal :openedId="openedId" v-model="showTchLessonLeaveModal" :title="lessonTitle"
                         :beginTime="lsnBeginTime" :successCallback="searchWithPage"/>
    <LessonCancelModal :openedId="openedId" :lsnType="lsnType" :tchChannel="tchChannel" v-model="showLessonCancelModal"
                       :successCallback="searchWithPage"/>
    <LessonFeedBackModal :openedId="openedId" :uid="uid" :tchId="tchId" :userNickname="userNickname"
                         v-model="showLessonFeedBackModal"/>
    <UserOneLeaveModal :openId="openId" :title="lessonTitle" :beginTime="lsnBeginTime" v-model="showUserOneLeaveModal"
                       @on-close="closeModal" :successCallback="searchWithPage"/>
    <UserInfoModal :value="editUser" @on-close="closeModal" :uid="uid" :successCallback="searchWithPage"/>
    <tch-info-modal :value="showTchInfoModal" @on-close="showTchInfoModal=false" :tchId="tchId"
                    :successCallback="searchWithPage"/>
    <SearchChangeTchModal :optType="optType" :user="tempLessonUser" :changeTeacherOnly="changeTeacherOnly"
                          v-model="showSearchChangeTchModal" :successCallback="searchWithPage"></SearchChangeTchModal>
    <UserTempLessonModal :user="tempLessonUser" v-model="showUserTempLessonModal"
                         :successCallback="searchWithPage"></UserTempLessonModal>
    <AddClassRequirementModal
      :uid="currentUid"
      :studentName="currentStudentName"
      :tchId="currentTchId"
      :bookLessonOpenedId="currentOpenedId"
      :tchName="currentTchName"
      :class-requirement="classRequirement"
      :class-requirement-tags="classRequirementTags"
      :successCallback="searchWithPage"
      v-model="showAddClassRequirementModal"></AddClassRequirementModal>
    <BookTchFeedbackModal :openedId="openedId" :readonly="true" v-model="showBookTchFeedbackModal" @on-close="showBookTchFeedbackModal=false"></BookTchFeedbackModal>
    <BookTchScoreFeedbackModal :openedId="openedId" :readonly="true" v-model="showBookTchScoreFeedbackModal" @on-close="showBookTchScoreFeedbackModal=false"></BookTchScoreFeedbackModal>
    <BookUserFeedbackModal :openedId="openedId" v-model="showBookUserFeedbackModal" @on-close="showBookUserFeedbackModal=false"></BookUserFeedbackModal>
    <StudentWriteReviewDemoModal :openedId="openedId" :readonly="true" :value="studentWriteReviewDemoModal" @on-close="studentWriteReviewDemoModal=false"></StudentWriteReviewDemoModal>
    <StudentWriteReviewRegularModal :openedId="openedId" :readonly="true" :value="studentWriteReviewRegularModal" @on-close="studentWriteReviewRegularModal=false"></StudentWriteReviewRegularModal>
    <StudentWriteReviewFinishLevelModal :openedId="openedId" :readonly="true" :value="studentWriteReviewFinishLevelModal" @on-close="studentWriteReviewFinishLevelModal=false"></StudentWriteReviewFinishLevelModal>
    <StudentWriteReviewDemoV2Modal :openedId="openedId" :readonly="true" :value="studentWriteReviewDemoV2Modal" @on-close="studentWriteReviewDemoV2Modal=false"></StudentWriteReviewDemoV2Modal>
    <StudentWriteReviewRegularV2Modal :openedId="openedId" :readonly="true" :value="studentWriteReviewRegularV2Modal" @on-close="studentWriteReviewRegularV2Modal=false"></StudentWriteReviewRegularV2Modal>
    <StudentWriteReviewFinishLevelV2Modal :openedId="openedId" :readonly="true" :value="studentWriteReviewFinishLevelV2Modal" @on-close="studentWriteReviewFinishLevelV2Modal=false"></StudentWriteReviewFinishLevelV2Modal>
    <Modal v-model="showClassFeedback" title="课堂反馈" width="960" :footer-hide="true" :mask-closable="false">
      <class-feedback
        v-if="showClassFeedback"
        :lesson-opened-id="classFeedbackOpenedId"
        :embedded="true"
        @saved="onClassFeedbackSaved"
      ></class-feedback>
    </Modal>
  </div>
</template>
<style>
.opened-list .ivu-table-cell {
  padding-left: 8px;
  padding-right: 8px;
}
.opened-list .ivu-table td {
  padding: 0 !important;
}

.opened-list .ivu-table-cell {
  padding: 0 !important;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<script>
import ChangeLessonModal from './ChangeLessonModal.vue'
import ChangeClassTypeModal from './ChangeClassTypeModal.vue'
import AddMonitorLessonRecordModal from './modal/AddMonitorLessonRecordModal.vue'
import TchLessonLeaveModal from '../teacher/TchLessonLeaveModal.vue'
import LessonCancelModal from '../lesson/LessonCancelModal.vue'
import UserOneLeaveModal from './UserOneLeaveModal.vue'
import UserInfoModal from '../crm/UserInfoModal.vue'
import TchInfoModal from '../teacher/modal/TchInfoModal.vue'
import dates from '@/tools/date/dates.js'
import LessonFeedBackModal from './LessonFeedBackModal.vue'
import SearchChangeTchModal from './modal/SearchChangeTchModal.vue'
import UserTempLessonModal from '../user/modal/UserTempLessonModal.vue'
import AddLessonFeedbackModal from './modal/AddLessonFeedbackModal.vue'
import AddClassRequirementModal from '../teacher/modal/AddClassRequirementModal.vue'
import BookTchFeedbackModal from './BookTchFeedbackModal.vue'
import BookTchScoreFeedbackModal from './BookTchScoreFeedbackModal.vue'
import BookUserFeedbackModal from './BookUserFeedbackModal.vue'
import StudentWriteReviewDemoModal from '../user/StudentWriteReviewDemoModal.vue'
import StudentWriteReviewRegularModal from '../user/StudentWriteReviewRegularModal.vue'
import StudentWriteReviewFinishLevelModal from '../user/StudentWriteReviewFinishLevelModal.vue'
import StudentWriteReviewDemoV2Modal from '../user/StudentWriteReviewDemoV2Modal.vue'
import StudentWriteReviewRegularV2Modal from '../user/StudentWriteReviewRegularV2Modal.vue'
import StudentWriteReviewFinishLevelV2Modal from '../user/StudentWriteReviewFinishLevelV2Modal.vue'
import ClassFeedback from './ClassFeedback.vue'
export default {
  components: {
    UserTempLessonModal,
    LessonFeedBackModal,
    ChangeLessonModal,
    ChangeClassTypeModal,
    AddMonitorLessonRecordModal,
    TchLessonLeaveModal,
    LessonCancelModal,
    UserOneLeaveModal,
    UserInfoModal,
    SearchChangeTchModal,
    TchInfoModal,
    AddLessonFeedbackModal,
    AddClassRequirementModal,
    BookTchFeedbackModal,
    BookTchScoreFeedbackModal,
    BookUserFeedbackModal,
    StudentWriteReviewDemoModal,
    StudentWriteReviewRegularModal,
    StudentWriteReviewFinishLevelModal,
    StudentWriteReviewDemoV2Modal,
    StudentWriteReviewRegularV2Modal,
    StudentWriteReviewFinishLevelV2Modal,
    ClassFeedback
  },
  data: function () {
    let $constant = this.$constant
    let $moment = this.$moment
    return {
      searchLoading: false,
      exportLoading: false,
      editUser: false,
      uid: null,
      showTchInfoModal: false,
      unifiedHolidayModal: false,
      showSearchChangeTchModal: false,
      showUserTempLessonModal: false,
      changeTeacherOnly: false,
      optType: 0,
      tchId: null,
      userNickname: '',
      reload: 0,
      reloadWithPage: 0,
      param: {
        date: dates.today(),
        studyAdviserId: '',
        keywords: '',
        totalCount: 0,
        isAudition: null,
        category: null,
        tchType: null,
        accent: null,
        sex: null,
        pageIndex: 1,
        pageSize: 20,

      },
      queryParam: {
        tchId: '',
        tchName: '',
        tchEmail: '',
        materialVersionId: '',
        isStudyAdviser: '',
        uid: '',
        userMobile: '',
        userNickname: '',
        adviserNickname: '',
        studyAdviserNickname: '',
        tchCategory: '',
        lsnSelStatus: '',
        lsnSelStatusList: [],
        lsnType: '',
        courseType: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        startCreateDate: '',
        endCreateDate: '',
        startCreateTime: '',
        endCreateTime: '',
        adviserId: '',
        adviserIds: [],
        operatorIds: [],
        regStartDate: '',
        regEndDate: '',
        regStartTime: '',
        regEndTime: '',
        creatorName: '',
        adminUserId: '',
        regType: '',
        tchChannel: '',
        tchStudyAdviserId: '',
        isLastSection: '',
        levelId: '',
        lessonId: '',
      },
      holidayParam: {
        startTime: '',
        endTime: '',
        content: ''
      },
      tempLessonUser: {},
      holidayRule: {
        startTime: [
          {required: true, message: '请选择开始时间', trigger: 'blur'},
        ],
        endTime: [
          {required: true, message: '请选择结束时间', trigger: 'change'}
        ],
        content: [
          {required: true, max: 100, message: '长度不要超过100个字符', trigger: 'blur'}
        ],
      },
      weekMap: {
        'Sun': '周日',
        'Mon': '周一',
        'Tue': '周二',
        'Wed': '周三',
        'Thu': '周四',
        'Fri': '周五',
        'Sat': '周六'
      },
      tchStudyAdviserList: [],
      bookMaterialLevelList: [],
      bookMaterialLessonsList: [],
      selectionOpenedIds: [],
      openedId: null,
      lsnType: null,
      openId: null,
      lessonOpened: {},
      classType: null,
      lessonTitle: null,
      lsnBeginTime: null,
      showChangeLessonModal: false,
      showChangeLClassTypeModal: false,
      showMonitorLessonRecordModal: false,
      showTchLessonLeaveModal: false,
      showLessonCancelModal: false,
      showLessonFeedBackModal: false,
      tchChannel: null,
      showUserOneLeaveModal: false,
      addLessonFeedbackModal: false,
      studentName: '',
      teacherName: '',
      lessonTime: '',
      showAddClassRequirementModal: false,
      showBookTchFeedbackModal: false,
      showBookTchScoreFeedbackModal: false,
      showBookUserFeedbackModal: false,
      studentWriteReviewDemoModal: false,
      studentWriteReviewRegularModal: false,
      studentWriteReviewFinishLevelModal: false,
      studentWriteReviewDemoV2Modal: false,
      studentWriteReviewRegularV2Modal: false,
      studentWriteReviewFinishLevelV2Modal: false,
      showClassFeedback: false,
      classFeedbackOpenedId: '',
      classFeedbackRow: null,
      currentUid: null,
      currentTchId: null,
      currentOpenedId: null,
      currentTchName: '',
      classRequirement: '',
      classRequirementTags: [],
      currentStudentName: '',
      showCameraStatus: false,
      title: [
        {
          type: 'selection',
          width: 40,
          align: 'center'
        },
        {
          title: '课程ID',
          align: 'center',
          width: 80,
          key: 'id',
        },
        {
          title: '课程信息',
          width: 140,
          render: (h, params) => {
            let row = params.row
            let lsnType = row.lsnType
            let title = row.lessonTitle
            let lsnTypeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType)
            let courseType = row.courseType
            let typeEnum = $constant.getEnum($constant.courseType, courseType)
            let cType = typeEnum && typeEnum.text
            if (cType) {
              cType = '课程类别：' + cType
            } else {
              cType = ''
            }
            return h('div', {style: {'font-size': '13px'}}, [h('p', {style: {color: '#2d8cf0'}}, title),
              h('p', '课程类型：' + (lsnTypeEnum && lsnTypeEnum.text)),
              h('p', cType)])
          }
        },
        {
          title: '当前上课时间',
          align: 'center',
          width: 170,
          render: (h, params) => {
            const lsnBeginTime = params.row.lsnBeginTime
            const isHighlighted = params.row.firstLesson || false
            // 确保填充整个单元格的样式
            const cellStyle = {
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              ...(isHighlighted ? { backgroundColor: '#adf3c1' } : {})
            }

            // 格式化日期和星期
            const date = $moment(lsnBeginTime, 'X')
            const dateStr = date.format('YYYY-MM-DD HH:mm')
            const weekStr = this.weekMap[date.format('ddd')] || date.format('ddd')

            return h('div', { style: cellStyle }, [
              h('div', dateStr),
              h('div', {style: { fontSize: '12px', marginTop: '2px' }}, weekStr)
            ])
          }
        },
        {
          title: '固定上课时间',
          align: 'center',
          width: 120,
          render: (h, params) => {
            let row = params.row
            let tchBoundNum = row.bookWorkLessonOpenedTimeList
            if (tchBoundNum) {
              let list = row.bookWorkLessonOpenedTimeList
              let spanArr = []
              if (list) {
                list.forEach(function (element) {
                  let startTime = $moment.unix(element.startTime).utc().format(' HH:mm')
                  spanArr.push(h('span', [h('span', {style: {color: '#2d8cf0'}}),
                    h('span', '[' + $constant.weekZh[element.week] + startTime + ']')]))
                  spanArr.push(h('br'))
                })
              }
              return h('div', {style: {'font-size': '12px'}}, [h('p', spanArr)])
            } else {
              return h('div', '未绑定')
            }
          }
        },
        {
          title: '当前老师',
          align: 'center',
          width: 220,
          render: (h, params) => {
            let row = params.row
            let isChange = ''
            if (row.isNewTch === 1) {
              isChange = '(替)'
            }
            // 状态标记显示逻辑
            let statusText = ''
            let statusClass = ''
            if (row.tchAbsent === 1) {
              statusText = '缺席'
              statusClass = 'status-absent'
            } else if (row.tchLate === 1) {
              statusText = '迟到'
              statusClass = 'status-late'
            }

            const statusTag = statusText ? h('span', {class: `status-tag ${statusClass}`}, ` [${statusText}]`) : null

            // 构建内容数组
            const content = [
              h('span', row.tchId + '-' + row.tchFirstName + ' ' + row.tchLastName + isChange)
            ]

            // 如果已接收体验课消息，添加绿色对号图标
            if (row.tchReceivedDemoMsg > 0) {
              content.push(h('Icon', {
                props: {
                  type: 'md-checkmark-circle',
                  color: '#19be6b'
                },
                style: {
                  marginLeft: '4px',
                  fontSize: '16px'
                },
                domProps: {
                  innerHTML: '✅'
                }
              }))
            } else {
              const hasClassRequirement = row.classRequirement && typeof row.classRequirement === 'string' && row.classRequirement.trim().length > 0
              const hasClassRequirementTags = row.classRequirementTags && Array.isArray(row.classRequirementTags) && row.classRequirementTags.length > 0
              if (hasClassRequirement || hasClassRequirementTags) {
                content.push(h('Icon', {
                  props: {
                    type: 'md-checkmark-circle',
                    color: '#c5c8ce'
                  },
                  style: {
                    marginLeft: '4px',
                    fontSize: '16px',
                    filter: 'grayscale(100%)'
                  },
                  domProps: {
                    innerHTML: '✅'
                  }
                }))
              }
            }
            if (statusTag) {
              content.push(statusTag)
            }

            // 设备状态图标显示
            const deviceStatusIcons = []

            // 摄像头状态：0-未检测，1-正常，2-不正常
            if (row.cameraStatus === 1) {
              deviceStatusIcons.push(h('Icon', {
                props: {
                  type: 'ios-videocam',
                  color: '#19be6b'
                },
                style: {
                  marginRight: '4px',
                  fontSize: '16px'
                },
                title: '摄像头正常'
              }))
            } else if (row.cameraStatus === 2) {
              deviceStatusIcons.push(h('span', {
                style: {
                  marginRight: '4px',
                  fontSize: '16px',
                  color: '#909399',
                  filter: 'grayscale(100%)',
                  opacity: 0.5,
                  cursor: 'default'
                },
                attrs: {
                  title: '摄像头异常'
                }
              }, '📹'))
            }

            // 麦克风状态：0-未检测，1-正常，2-不正常
            if (row.micStatus === 1) {
              deviceStatusIcons.push(h('Icon', {
                props: {
                  type: 'ios-mic',
                  color: '#19be6b'
                },
                style: {
                  marginRight: '4px',
                  fontSize: '16px'
                },
                title: '麦克风正常'
              }))
            } else if (row.micStatus === 2) {
              deviceStatusIcons.push(h('Icon', {
                props: {
                  type: 'ios-mic-off',
                  color: '#909399'
                },
                style: {
                  marginRight: '4px',
                  fontSize: '16px'
                },
                title: '麦克风异常'
              }))
            }

            // 耳机状态：0-未检测，1-正常，2-不正常
            if (row.headphoneStatus === 1) {
              deviceStatusIcons.push(h('span', {
                style: {
                  marginRight: '4px',
                  fontSize: '16px',
                  cursor: 'default'
                },
                attrs: {
                  title: '耳机正常'
                }
              }, '🎧'))
            } else if (row.headphoneStatus === 2) {
              deviceStatusIcons.push(h('span', {
                style: {
                  marginRight: '4px',
                  fontSize: '16px',
                  color: '#909399',
                  filter: 'grayscale(100%)',
                  opacity: 0.5,
                  cursor: 'default'
                },
                attrs: {
                  title: '耳机异常'
                }
              }, '🎧'))
            }

            // 如果有设备状态图标，添加到内容中另起一行显示
            if (deviceStatusIcons.length > 0) {
              // content.push(h('div', {
              //   style: {
              //     marginTop: '4px',
              //     display: 'flex',
              //     justifyContent: 'center',
              //     alignItems: 'center'
              //   }
              // }, deviceStatusIcons))
            }
            let str = ''
            if (row.openCamara === 0 && this.showCameraStatus) {
              str = '课前未打开摄像头'
            }

            return h('div', {style: {display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}, [
              h('a', {on: {click: () => this.openNewLessonModal(row.tchId, row.tchFirstName + row.tchLastName)}}, content),
              h('span', {style: {color: 'red'}}, str)
            ])
          }
        },
        {
          title: '学生ID、姓名',
          align: 'center',
          width: 180,
          render: (h, params) => {
            let row = params.row

            // 状态标记显示逻辑
            let statusText = ''
            let statusClass = ''
            if (row.stdAbsent === 1) {
              statusText = '缺席'
              statusClass = 'status-absent'
            } else if (row.stdLate === 1) {
              statusText = '迟到'
              statusClass = 'status-late'
            }

            const statusTag = statusText ? h('span', {class: `status-tag ${statusClass}`}, ` [${statusText}]`) : null

            // 构建内容数组
            const textStyle = row.stdLeaveRule === 2 ? { fontWeight: 'bold', fontSize: '15px' } : {}
            const content = [
              h('span', { style: textStyle }, row.uid + '-' + row.userNickname)
            ]

            if (statusTag) {
              content.push(statusTag)
            }

            return h('div', {style: {display: 'flex', flexDirection: 'column', alignItems: 'center'}}, [
              h('a', {on: {click: () => this.openInfoModal(row.uid)}}, content)
            ])
          }
        },
        {
          title: '学生手机号',
          align: 'center',
          width: 120,
          key: 'mobile',
          render: (h, params) => {
            let row = params.row
            return h('Poptip', {
              props: {
                trigger: 'hover'
              }
            }, [
              h('span',
                row.mobile.length === 11 ? row.mobile.substring(0, 3) +
                  '****' + row.mobile.substring(7) : row.mobile),
              // 当前行展示的数据
              h('div', {slot: 'content'}, row.mobile)
            ])
          }
        },
        {
          title: '课节情况',
          width: 120,
          render: (h, params) => {
            let row = params.row
            return h('div', [h('p', '已上课:' + (row.endLessonNum)), h('p', '总课节:' + (row.routineNum))])
          }
        },
        /* {
          title: '待上课时',
          align: 'center',
          width: 80,
          key: 'waitLessonNum'
        }, */
        /*   {
             title: '注册时间',
             width: 170,
             align: 'center',
             key: 'gmtCreate'
           }, */
        {
          title: '学导',
          align: 'center',
          width: 110,
          key: 'studyAdviserNickname'
        },
        /*          {
                    title: '课程名称',
                    width: 130,
                    key: 'lessonTitle'
                  },
                  */
        {
          title: '课程顾问',
          width: 110,
          key: 'adviserNickname'
        },
        {
          title: '外管',
          align: 'center',
          width: 110,
          key: 'tchStudyName'
        },
        {
          title: '状态',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let lsnSelStatus = params.row.lsnSelStatus
            let statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus)
            return h('span', statusEnum && statusEnum.text)
          }
        },
        {
          title: '渠道',
          align: 'center',
          width: 140,
          render: (h, params) => {
            let row = params.row
            let children = [h('span', row.regType || '')]
            if (row.inviteId) {
              children.push(h('br'))
              children.push(h('span', {style: {fontSize: '12px', color: '#E6A23C'}}, row.inviteId + '-' + (row.inviteName || '')))
            }
            return h('div', children)
          }
        },
        {
          title: '课堂反馈',
          align: 'center',
          width: 140,
          render: (h, params) => {
            let row = params.row
            let n = parseInt(row.classFeedbackStar, 10)
            if (row.lsnSelStatus === 1 && (!n || n < 1)) {
              return h('span', '未评分')
            }
            if (!n || n < 1) {
              return h('a', {
                style: {color: '#2d8cf0', cursor: 'pointer'},
                on: {
                  click: () => {
                    this.openClassFeedback(row)
                  }
                }
              }, '去评分')
            }
            if (n > 5) {
              n = 5
            }
            return h('span', {
              style: {color: '#f0a020', cursor: 'pointer', fontSize: '16px', letterSpacing: '1px'},
              on: {
                click: () => {
                  this.openClassFeedback(row)
                }
              }
            }, '★'.repeat(n))
          }
        },
        {
          title: '操作时间',
          width: 170,
          align: 'center',
          key: 'gmtModified'
        },
        /*  {
           title: '创建人',
           width: 100,
           key: 'creatorName'
         },
         {
           title: '最后操作人',
           width: 100,
           key: 'adminNickname'
         }, */
        /*    {
              title: '排课时间',
              width: 170,
              render: (h, params) => {
                let lsnBeginTime = params.row.lessonOpenTime
                return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm'))
              }
            }, */
        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 80,
          render: (h, params) => {
            let row = params.row
            let id = row.id
            let lsnType = row.lsnType
            let lessonTitle = row.lessonTitle
            let lsnBeginTime = row.lsnBeginTime
            let tchChannel = row.tchChannel
            let btn = []
            btn.push(h('Dropdown-item', {props: {name: 'lessonUrl'}}, '课程链接'))
            if (row.lsnSelStatus === 1) {
              let time = new Date().getTime()
              if (lsnBeginTime * 1000 - time >= 20 * 60 * 1000) {
                btn.push(h('Dropdown-item', {props: {name: 'changeLesson'}}, '调课件'))
              }
              btn.push(h('Dropdown-item', {props: {name: 'userTemp'}}, '临时约课'))
              btn.push(h('Dropdown-item', {props: {name: 'userLeave'}}, '学生请假'))
              // btn.push(h('Dropdown-item', {props: {name: 'tchLeave'}}, '老师请假'))
              if (row.lsnSelStatus !== 2 && lsnBeginTime * 1000 > time) {
                btn.push(h('Dropdown-item', {props: {name: 'cancelLesson'}}, '取消课程'))
              }
              if (row.isNewTch === 1) {
                btn.push(h('Dropdown-item', {props: {name: 'cancelProxy'}}, '取消代课'))
              }
              btn.push(h('Dropdown-item', {props: {name: 'classRequire'}}, '上课要求'))
              if (row.isRecordScreen === 1) {
                btn.push(h('Dropdown-item', {props: {name: 'closeRecordScreen'}}, '关闭录屏'))
              } else {
                btn.push(h('Dropdown-item', {props: {name: 'openRecordScreen'}}, '开启录屏'))
              }
              if (lsnBeginTime * 1000 > time + 20 * 60 * 1000) {
                // btn.push(h('Dropdown-item', {props: {name: 'changeTeacherOnly'}}, '更换老师/时间'))
              }
              btn.push(h('Dropdown-item', {props: {name: 'reloadClassIn'}}, '手动生成ClassIn ID'))
            }
            if (row.lsnSelStatus === 6 || row.lsnSelStatus === 13) {
              let time = new Date().getTime()
              if (lsnBeginTime * 1000 > time) {
                btn.push(h('Dropdown-item', {props: {name: 'proxyLesson'}}, '老师代课'))
              }
            }
            if (row.makeUp === 1) {
              btn.push(h('Dropdown-item', {props: {name: 'cancelMakeUp'}}, '取消补课'))
            } else {
              btn.push(h('Dropdown-item', {props: {name: 'confirmMakeUp'}}, '补课'))
            }
            if (row.lsnSelStatus <= 3 && row.liveUrl) {
              btn.push(h('Dropdown-item', {props: {name: 'viewRecordScreen'}}, '监课/回放'))
            }
            if (row.lsnSelStatus === 3 || row.lsnSelStatus === 6 || row.lsnSelStatus === 13) {
              // btn.push(h('Dropdown-item', {props: {name: 'userAbsent'}}, '学生旷课'))
              // btn.push(h('Dropdown-item', {props: {name: 'tchAbsent'}}, '老师旷课'))
              btn.push(h('Dropdown-item', {props: {name: 'lessonFeedBack'}}, '我要投诉'))
              btn.push(h('Dropdown-item', {props: {name: 'addLessonFeedback'}}, '上课反馈'))
              btn.push(h('Dropdown-item', {props: {name: 'classRequire'}}, '上课要求'))
              btn.push(h('Dropdown-item', {props: {name: 'viewTchFeedback'}}, '查看外教评价'))
            }



            // btn.push(h('Dropdown-item', {props: {name: 'monitorLesson'}}, '添加监课记录'))

            return h('div', [
              h('Dropdown', {
                props: {
                  transfer: true,
                  trigger: 'click',
                  placement: 'bottom-end'
                },
                on: {
                  'on-click': (name) => {
                    if (name === 'reloadClassIn') {
                      this.onReloadClassIn(row)
                    } else if (name === 'lessonUrl') {
                      window.open('https://medias.kouyujie.cn/' + row.filePath)
                    } else if (name === 'changeLesson') {
                      this.lessonOpened = row
                      this.showChangeLessonModal = true
                    } else if (name === 'userLeave') {
                      this.openId = id
                      this.lessonTitle = lessonTitle
                      this.lsnBeginTime = lsnBeginTime
                      this.showUserOneLeaveModal = true
                      // this.onUserLeave(id)
                    } else if (name === 'tchLeave') {
                      this.openedId = id
                      this.lessonTitle = lessonTitle
                      this.lsnBeginTime = lsnBeginTime
                      this.showTchLessonLeaveModal = true
//                        this.onTchLeave(id)
                    } else if (name === 'cancelLesson') {
                      this.openedId = id
                      this.uid = row.uid
                      this.tchId = row.tchId
                      this.lsnType = lsnType
                      this.showLessonCancelModal = true
                      this.tchChannel = tchChannel
                    } else if (name === 'userAbsent') {
                      this.onUserAbsent(row)
                    } else if (name === 'confirmMakeUp') {
                      this.onConfirmMakeUp(row)
                    } else if (name === 'tchAbsent') {
                      this.onTchAbsent(row)
                    } else if (name === 'monitorLesson') {
                      this.openedId = id
                      this.showMonitorLessonRecordModal = true
                    } else if (name === 'closeRecordScreen') {
                      this.closeRecordScreen(row)
                    } else if (name === 'openRecordScreen') {
                      this.openRecordScreen(row)
                    } else if (name === 'viewRecordScreen') {
                      this.viewRecordScreen(row)
                    } else if (name === 'lessonFeedBack') {
                      this.lessonFeedBack(row)
                    } else if (name === 'proxyLesson') {
                      this.tempLessonUser = row
                      this.showSearchChangeTchModal = true
                      this.changeTeacherOnly = false
                      this.optType = 1
                    } else if (name === 'changeTeacherOnly') {
                      this.tempLessonUser = row
                      this.showSearchChangeTchModal = true
                      this.changeTeacherOnly = true
                      this.optType = 2
                    } else if (name === 'userTemp') {
                      this.showUserTempLessonModal = true
                      this.tempLessonUser = {
                        id: row.uid,
                        nickname: row.nickname,
                        levelId: row.levelId,
                        mobile: row.mobile,
                      }
                    } else if (name === 'cancelProxy') {
                      this.cancelProxy(row)
                    } else if (name === 'addLessonFeedback') {
                      this.openedId = id
                      this.studentName = row.uid + '-' + row.userNickname
                      this.teacherName = row.tchId + '-' + row.tchFirstName + ' ' + row.tchLastName + (row.isNewTch === 1 ? '(替)' : '')
                      this.lessonTime = $moment(row.lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm')
                      this.addLessonFeedbackModal = true
                    } else if (name === 'classRequire') {
                      this.currentUid = row.uid
                      this.currentStudentName = row.userNickname
                      this.currentTchId = row.tchId
                      this.currentOpenedId = row.id
                      this.currentTchName = row.tchFirstName + ' ' + row.tchLastName
                      this.classRequirement = row.classRequirement || ''
                      this.classRequirementTags = row.classRequirementTags || []
                      this.showAddClassRequirementModal = true
                    } else if (name === 'viewTchFeedback') {
                      this.viewTchFeedback(row)
                    }
                  }
                }
              }, [
                h('a', [
                  h('span', '更多 '),
                  h('Icon', {props: {type: 'ios-arrow-down'}})
                ]),
                h('Dropdown-menu', {slot: 'list'}, btn)
              ])
            ])
          }
        }
      ]
    }
  },
  mounted: function () {
    this.init()
    let self = this
    self.queryParam.uid = this.$route.query.uid
    self.queryParam.adviserId = this.$route.query.adviserId
    self.$http.post('/adminUser/listByCondition', {adminGroupId: 7}).then(function (res) {
      self.tchStudyAdviserList = res.data
    })
    this.loadBookMaterialLevel()
  },
  created: function () {
    let self = this
    let startTime = self.queryParam.startTime
    if (startTime !== '') {
      this.queryParam.startTimeDate = this.$moment.unix(startTime).toDate()
    }
    if (startTime === '') {
      let momentDate = this.$moment()
      momentDate.millisecond(0)
      momentDate.second(0)
      momentDate.minute(0)
      momentDate.hour(0)
      self.queryParam.startTimeDate = momentDate.toDate()
      self.queryParam.startTime = momentDate.format('X')
    }
  },
  methods: {
    init () {
      let self = this
      let query = self.$route.query
      if (query) {
        if (query.regStartDate) {
          self.queryParam.regStartDate = parseInt(query.regStartTime) * 1000
        }
        if (query.regEndDate) {
          self.queryParam.regEndDate = parseInt(query.regEndTime) * 1000
        }
        if (query.startTimeDate) {
          self.queryParam.startTimeDate = parseInt(query.startTime) * 1000
        }
        if (query.fromCrm === 1) {
          self.queryParam.startTimeDate = ''
        }
        if (query.endTimeDate) {
          self.queryParam.endTimeDate = parseInt(query.endTime) * 1000
        }
        if (query.startCreateDate) {
          self.queryParam.startCreateDate = parseInt(query.startCreateTime) * 1000
        }
        if (query.endCreateDate) {
          self.queryParam.endCreateDate = parseInt(query.endCreateTime) * 1000
        }
        if (query.tchId) {
          self.queryParam.tchId = parseInt(query.tchId)
        }
        if (query.tchName) {
          self.queryParam.tchName = query.tchName
        }
        if (query.materialVersionId) {
          self.queryParam.materialVersionId = parseInt(query.materialVersionId)
        }
        if (query.levelId) {
          self.queryParam.levelId = parseInt(query.levelId)
        }
        if (query.lessonId) {
          self.queryParam.lessonId = parseInt(query.lessonId)
        }
        if (query.levelId) {
          self.changeMaterialLevel(self.queryParam.levelId, true)
        }
        if (query.isStudyAdviser) {
          self.queryParam.isStudyAdviser = query.isStudyAdviser
        }
        if (query.uid) {
          self.queryParam.uid = parseInt(query.uid)
        }
        if (query.userMobile) {
          self.queryParam.userMobile = query.userMobile
        }
        if (query.userNickname) {
          self.queryParam.userNickname = query.userNickname
        }
        if (query.adviserNickname) {
          self.queryParam.adviserNickname = query.adviserNickname
        }
        if (query.studyAdviserNickname) {
          self.queryParam.studyAdviserNickname = query.studyAdviserNickname
        }
        if (query.tchCategory) {
          self.queryParam.tchCategory = parseInt(query.tchCategory)
        }
        if (query.lsnSelStatus) {
          self.queryParam.lsnSelStatus = parseInt(query.lsnSelStatus)
        }
        // if (query.lsnSelStatusList) {
        //   let statusList = query.lsnSelStatusList
        //   if (typeof statusList === 'string') {
        //     statusList = [statusList]
        //   }
        //   self.queryParam.lsnSelStatusList = statusList.map(item => parseInt(item))
        // }
        if (query.lsnType) {
          self.queryParam.lsnType = parseInt(query.lsnType)
        }
        if (query.courseType) {
          self.queryParam.courseType = parseInt(query.courseType)
        }
        if (query.adviserId) {
          self.queryParam.adviserId = parseInt(query.adviserId)
        }
        if (query.creatorName) {
          self.queryParam.creatorName = query.creatorName
        }
      }
    },
    openTchInfoModal (val, classIn) {
      this.tchId = val
      this.showTchInfoModal = true
    },
    search () {
      this.selectionOpenedIds = []
      this.reload = new Date().getTime()
    },
    loadBookMaterialLevel () {
      let self = this
      self.$http.get('/bookMaterialLevel/listByCondition?status=1').then(function (res) {
        if (!res || !res.data) {
          return
        }
        self.bookMaterialLevelList = res.data
      })
    },
    changeMaterialLevel (val, skipSearch) {
      if (!skipSearch) {
        this.queryParam.lessonId = ''
      }
      this.bookMaterialLessonsList = []
      if (val) {
        let self = this
        self.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val).then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.bookMaterialLessonsList = res.data
        })
      }
      if (!skipSearch) {
        this.search()
      }
    },
    exportData () {
      this.exportLoading = true
      this.$http.get('/bookLesson/regularClass/export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '常规课程列表.csv'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    },
    searchWithPage () {
      this.reloadWithPage = new Date().getTime()
    },
    closeModal (val) {
      this.uid = null
      this.editUser = false
      this.UserOneLeaveModal = val
    },
    openInfoModal (val) {
      this.uid = val
      let {href} = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/lesson/BookLessonOpenedList'}
      })
      window.open(href, '_blank')
    },
    openNewLessonModal (k, v) {
      if (this.$appConfig.active === 'prod') {
        window.open('https://bops.kouyujie.cn/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v)
      } else {
        window.open('https://develop.bops.kouyujie.cn/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v)
      }
    },
    onLoading (loading) {
      this.searchLoading = loading
    },
    startTimeDateChange (value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endTimeDateChange (value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    startCreateTimeChange (value) {
      this.queryParam.startCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endCreateTimeChange (value) {
      this.queryParam.endCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    startTimeRegChange (value) {
      this.queryParam.regStartTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endTimeRegChange (value) {
      this.queryParam.regEndTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    startTimeHolidayChange (value) {
      this.holidayParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endTimeHolidayChange (value) {
      this.holidayParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    onUserLeave (id) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>学生</b> 请假？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/bookUserLeaveTime/addByOpenedId', {openedId: id}).then(function (res) {
            if (res) {
              self.search()
              self.$Message.success('请假成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    onTchLeave (id) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>老师</b> 请假？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookTchLeaveTime/addByOpenedId', {openedId: id}).then(function (res) {
            if (res) {
              self.search()
              self.$Message.success('请假成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    onUserAbsent (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>学生</b> 旷课？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookLesson/userAbsent', {id: row.id}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('处理成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    onConfirmMakeUp (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>学生</b> 补课？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookLesson/confirmMakeUp', {id: row.id}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('处理成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    onTchAbsent (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>老师</b> 旷课？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookLesson/tchAbsent', {id: row.id}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('处理成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    onReloadClassIn (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确定 手动生成ClassIn ID ？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/user/lesson/reloadClassIn', {openedId: row.id}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('生成成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    closeRecordScreen (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认<b>关闭</b>录屏？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookLesson/updateRecordScreen', {openedId: row.id, isRecordScreen: 0}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('处理成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    openRecordScreen (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认<b>开启</b>录屏？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookLesson/updateRecordScreen', {openedId: row.id, isRecordScreen: 1}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('处理成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    viewRecordScreen (row) {
      window.open(row.liveUrl)
      // this.$http.get('/bookLesson/getRecordScreenUrl?openedId=' + row.id).then(function (res) {
      //   window.open(res.data)
      // })
    },
    lessonFeedBack (row) {
      this.openedId = row.id
      this.uid = row.uid
      this.tchId = row.tchId
      this.userNickname = row.userNickname
      this.showLessonFeedBackModal = true
    },
    selectedChange (selection) {
      this.selectionOpenedIds = selection
    },
    batchCancelLesson () {
      if (this.selectionOpenedIds.length <= 0) {
        this.$Message.warning('请选择需要取消的课程！')
        return
      }
      let self = this
      let ids = []
      let startedCount = 0
      let now = Date.now()
      if (this.selectionOpenedIds && this.selectionOpenedIds.length > 0) {
        for (let i in this.selectionOpenedIds) {
          let dto = this.selectionOpenedIds[i]
          if (dto.lsnSelStatus === 2 || dto.lsnBeginTime * 1000 <= now) {
            startedCount++
          } else {
            ids.push(dto.id)
          }
        }
      }
      if (startedCount > 0) {
        this.$Message.warning('课程已开始，不可取消')
      }
      if (ids.length <= 0) {
        return
      }
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认取消已选课程？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/bookLesson/batchCancelLesson', {
            openedIds: ids.join(','),
            reason: '管理员取消'
          }).then(function (res) {
            self.search()
            self.$Message.success('操作成功!')
            self.$Modal.remove()
          })
        }
      })
    },
    saveHoliday () {
      let self = this
      let holidayValidate = 0
      if (this.holidayParam.startTime && this.holidayParam.startTime !== '') {
        holidayValidate += 1
      }
      if (this.holidayParam.endTime && this.holidayParam.endTime !== '') {
        holidayValidate += 1
      }
      if (this.holidayParam.content && this.holidayParam.content !== '') {
        holidayValidate += 1
      }
      if (holidayValidate !== 3) {
        return
      }
      self.$http.post('/holiday/insert', this.holidayParam).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('新增成功!')
          self.unifiedHolidayModal = false
          self.successCallback()
        } else {
          self.$Message.error('新增失败!')
        }
      }).catch(function (e) {
      })
    },
    cancelProxy (row) {
      let self = this
      self.tempLessonUser = row
      self.showSearchChangeTchModal = true
      self.changeTeacherOnly = true
      self.optType = 3
    },
    viewTchFeedback (row) {
      this.openedId = row.id
      if (row.lsnType === 1) {
        this.studentWriteReviewDemoV2Modal = true
      } else if (row.lsnType === 2) {
        if (row.stageSummary) {
          this.studentWriteReviewFinishLevelV2Modal = true
        } else {
          this.studentWriteReviewRegularV2Modal = true
        }
      }
    },
    openClassFeedback (row) {
      this.classFeedbackRow = row
      this.classFeedbackOpenedId = row.id
      this.showClassFeedback = true
    },
    onClassFeedbackSaved (payload) {
      let star = payload && payload.star
      let openedId = payload && payload.openedId
      let list = this.$refs.dataList
      let rows = list && list.tableData
      if (rows && rows.length) {
        for (let i = 0; i < rows.length; i++) {
          if (String(rows[i].id) === String(openedId)) {
            rows[i].classFeedbackStar = star
            break
          }
        }
        list.tableData = rows.slice()
      } else if (this.classFeedbackRow) {
        this.classFeedbackRow.classFeedbackStar = star
      }
      this.showClassFeedback = false
      this.classFeedbackRow = null
    }
  },
}
</script>
<style>
.opened-list .ivu-table-cell {
  padding-left: 8px;
  padding-right: 8px;
}
.opened-list .ivu-table td {
  padding: 0 !important;
}

.opened-list .ivu-table-cell {
  padding: 0 !important;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 状态标记样式 */
.status-tag {
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 3px;
  margin-left: 4px;
}

.status-absent {
  background-color: #ff6b6b;
  color: white;
}

.status-late {
  background-color: #ffd93d;
  color: #333;
}
</style>




// WEBPACK FOOTER //
// BookLessonOpenedList.vue?7202f367